var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"matchesPreferences"}},[_c('div',{staticClass:"container-lg preferencesContainer"},[(_vm.showBlocks)?_c('div',{staticClass:"rightContainer"},[_c('UserAccountMembership'),_c('PersonalDetails'),_c('MatchingSettings'),_c('Notifications')],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }